import { TRouteOverrides } from 'helpers/applyRouteOverrides'

import { FEMI_RETENTION_ROUTES } from 'modules/femiUnsubscribe/routes'

import { AppName } from 'root-constants'

export const APP_ROUTE_OVERRIDES: Partial<Record<AppName, TRouteOverrides>> = {
  [AppName.FEMI]: FEMI_RETENTION_ROUTES,
}
